<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Scope Definition
      <div slot="right">
        <b-button type="is-normal import-button" @click="redirectToScopes"
          >Back</b-button
        >
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <b-collapse class="validation-panel" animation="slide">
        <div class="card validation-card">
          <div class="card-content">
            <div class="columns">
              <div
                class="column columns no-margin"
                v-if="formData && formData.valid_from"
              >
                <div class="column">
                  <b-icon icon="calendar-start"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid From
                  </div>
                  <div class="columns">
                    <a ref="#">
                      <p class="no-padding validation-import-comments">
                        {{ formData.valid_from }}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin"
                v-if="formData && formData.valid_to"
              >
                <div class="column">
                  <b-icon icon="calendar-end"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Valid To
                  </div>
                  <div class="columns">
                    <a ref="#"
                      ><p class="no-padding validation-import-comments">
                        {{ formData.valid_to }}
                      </p>
                    </a>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="calendar-clock"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns validation-text-header">
                    Last Updated
                  </div>
                  <div class="columns">
                    <p class="no-padding" v-if="formData">
                      {{ formData.updated_at }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column columns no-margin" v-if="formData">
                <div class="column">
                  <b-icon icon="account-edit"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Last Updated by
                  </div>
                  <div class="columns">
                    <p class="no-padding">{{ formData.updated_by_name }}</p>
                  </div>
                </div>
              </div>
              <div
                class="column columns no-margin"
                v-if="!formData.valid_from"
              ></div>
              <div
                class="column columns no-margin"
                v-if="!formData.valid_to"
              ></div>
              <div class="column columns no-margin"></div>
              <div class="column columns no-margin">
                <div class="column">
                  <b-icon icon="content-save"></b-icon>
                </div>
                <div class="column is-three-quarters">
                  <div class="columns no-padding validation-text-header">
                    Current Status
                  </div>
                  <div class="columns">
                    <p
                      v-if="formData"
                      class="no-padding validation-import-status"
                    >
                      {{ formData.status }}
                    </p>
                    &nbsp;
                    <span
                      v-if="formData && formData.status == 'Rejected'"
                      class="additional-info"
                    >
                      <b-tooltip
                        type="is-primary"
                        :label="formData.comment_for_rejection"
                        multilined
                      >
                        <i class="mdi mdi-information"></i>
                      </b-tooltip>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </section>
    <section class="section is-main-section scope-main-section" v-if="formData">
      <div class="scope-bundle">
        <div class="scope" v-if="formData.country_name">
          <div class="country-with-flag">
            <country-flag
              :country="formData.country_code"
              size="small"
              v-if="formData.country_code"
            />
            <span class="scope-text">{{ formData.country_name }}</span>
          </div>
        </div>
        <hr class="scope-hr" />
      </div>
      <div class="scope-bundle" v-if="formData.scheme_name">
        <div class="scope">
          <span class="scope-text">{{ formData.scheme_name }}</span>
        </div>
        <hr class="scope-hr" />
      </div>
      <div class="scope-bundle" v-if="formData.stream_name">
        <div class="scope">
          <span class="scope-text">{{ formData.stream_name }}</span>
        </div>
        <hr class="scope-hr" />
      </div>
      <ul class="scope-rule-list">
        <li v-for="(value, index) in selectedRules" :key="index" class="scope">
          <span v-on:click="showRule(value)"
            ><a href="#">{{ value.name }}</a></span
          >
        </li>
      </ul>
    </section>

    <view-rules
      :is-active="isViewModalActive"
      :formData="viewRule"
      @cancel="cancelViewRule"
      :show-edit-button="false"
      :rule-tags="ruleTags"
    />
  </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";
import RulesManagerService from "../../services/RulesManagerService";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ViewRules from "@/components/RulesManager/ViewRules.vue";
export default {
  name: "ScopeDefinition",
  components: {
    HeroBar,
    TitleBar,
    ViewRules
  },
  mixins: [UtilityMixin],
  props: {
    isViewOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      viewRule: {},
      data: null,
      formData: [],
      isDataLoading: false,
      isViewModalActive: false,
      selectedRules: [],
      editObject: this.getClearFormObject(),
      RulesManagerService: new RulesManagerService(),
      ruleTags: []
    };
  },
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission"]),
    editObjectName() {
      return this.editObject || this.getClearFormObject();
    },
    titleStack() {
      return [
        { url: "#", name: "Rules Manager" },
        { url: "/rulesManager/scopes", name: "Scopes" },
        { url: "#", name: "Scope Definition View" }
      ];
    }
  },
  mounted() {
    this.checkExternalPermission();
    this.getScopeById();
    this.fetchRuleTags();
  },
  methods: {
    fetchRuleTags() {
      this.RulesManagerService.getRulesTags().subscribe(response => {
        this.ruleTags = response;
      });
    },
    showRule(value) {
      const tagSelected = this.ruleTags
        .filter(item => (value["tags"] ? value["tags"].includes(item.id) : ""))
        .map(a => a.name)
        .toString();

      value["tags"] = tagSelected == "" ? "NA" : tagSelected;
      this.isViewModalActive = true;
      this.viewRule = value;
    },
    cancelViewRule() {
      this.isViewModalActive = false;
    },

    getScopeById() {
      this.RulesManagerService.getScopeById(this.$route.params.id).subscribe(
        response => {
          this.formData = response;
          if (this.formData.status != "Approved") {
            this.selectedRules = this.formData.rule.filter(rule => rule.active);
          } else {
            this.selectedRules = this.formData.rule;
          }
          // this.selectedRules = this.formData.rule.filter(rule => rule.active);
          this.formData.updated_at
            ? (this.formData.updated_at = this.dateToLocalDate(
                this.formData.updated_at
              ))
            : null;
        }
      );
    },
    getClearFormObject() {
      this.formData = [];
    },
    redirectToScopes() {
      this.formData = [];
      this.$router.push({
        name: "rulesManager.scopes"
      });
    }
  }
};
</script>
